import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { DefaultQueryParams, parseQuery, useTranslation } from '@pascal/pascal-core';
import LogoImg from '../../assets/images/turbo-belote/logo-belote.png';
import { RoundCards } from '../../components/roundCards';
import { BottomContainer } from '../bottomContainer';
import { WinPopUp } from '../../components/winPopUp';
import { winningStore } from '../../store/winningStore';
import { gameStore } from '../../store/gameStore';

export const GameContent = observer(() => {
  const { isDemo } = applicationStore;
  const { winningAmount } = winningStore;
  const { currencyCode } = userInfoStore;
  const { resetGameState, isBetsClosed } = gameStore;
  const t = useTranslation();
  const { [DefaultQueryParams.RealModeSwitcher]: hasRealModeSwitcher } = parseQuery(
    window.location.search
  );

  const handleDemoSwitcher = useCallback(() => {
    applicationStore.demoSwitcher(resetGameState);
  }, [resetGameState]);

  return (
    <div className='turbo-belote-web-game-sec'>
      <div className='turbo-belote-web-game-content'>
        <div className='turbo-belote-web-game-top'>
          <div className='tb-game-top-content'>
            <img src={LogoImg} alt='Logo-belote' />
          </div>
          {!Number(hasRealModeSwitcher) && isDemo && (
            <div className='play-for-real-btn-wrp'>
              <button className='play-for-real-btn' onClick={handleDemoSwitcher}>
                {t('PLAY_FOR_REAL')}
              </button>
            </div>
          )}
        </div>
        <div className='turbo-belote-web-game-middle'>
          <div className='tb-game-mid-content'>
            <div className='tb-game-circle-shadow' />
            {!!winningAmount && (
              <WinPopUp winningAmount={winningAmount} currencyCode={currencyCode} />
            )}
            <div className='tb-game-cards-wrapper'>
              <RoundCards />
              {!isBetsClosed && (
                <div className='place-your-bet-wrp'>
                  <p className='place-your-bet-text'>{t('PLACE_YOUR_BETS')}</p>
                </div>
              )}
            </div>
          </div>
        </div>
        <BottomContainer />
      </div>
    </div>
  );
});
